export default "__VITE_ASSET__BVmkRTZD__"